import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EuiIconColorComponent } from './eui-icon-color.component';

@NgModule({
    imports: [CommonModule],
    exports: [EuiIconColorComponent],
    declarations: [EuiIconColorComponent],
})
export class EuiIconColorModule {
}
